import { Modal, ModalProps } from "components/common/Modal";
import React from "react";
import { ResourceType } from "types/graphqlapi";
import { ImagePresenter } from "components/common/ImagePresenter";
import { VideoPresenter } from "components/common/VideoPresenter";
import { DisplayInterviewResource } from "pages/FIleDLManagement/hook";
import {
  StyledMediaContainer,
  StyledModalContainer,
  StyledModalContent,
  StyledModalHeader,
} from "pages/FIleDLManagement/FileDLManageModal/styled";
import { Typography } from "components/parts/Typography/Typography";

type FileManageModalProps = {
  selectedFile: DisplayInterviewResource;
} & ModalProps;

export const FileDLManageModal: React.FC<FileManageModalProps> = ({
  selectedFile,
  closeHandler,
}) => {
  return (
    <Modal closeHandler={closeHandler}>
      <StyledModalContainer>
        <StyledModalHeader>
          <Typography text="プレビュー" size="large" />
        </StyledModalHeader>
        <StyledModalContent>
          <StyledMediaContainer>
            {selectedFile.type === ResourceType.VIDEO ? (
              <VideoPresenter
                src={selectedFile.src}
                controls
                maxWidth="80vw"
                maxHeight="70vh"
              />
            ) : (
              <ImagePresenter
                src={selectedFile.src}
                maxWidth="80vw"
                maxHeight="70vh"
              />
            )}
          </StyledMediaContainer>
        </StyledModalContent>
      </StyledModalContainer>
    </Modal>
  );
};
